import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import { Context } from "src/context";
import { handleAuthSuccess } from "src/utils";
import { ExchangeHisToken, HIS_NATIONAL_ID_PARAM, HIS_TOKEN_PARAM } from "src/requests/his";
import AddMedicine from "../DoctorOrders/AddMedicine/AddMedicine";
import "./style.css";

type Status = "pending" | "ready" | "failed";

const HisEmbed = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setIsLoggedIn, setCustomSearchData } = useContext(Context);

    const [status, setStatus] = useState<Status>("pending");
    const hasRun = useRef(false);

    const nationalId = searchParams.get(HIS_NATIONAL_ID_PARAM);

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;

        const token = searchParams.get(HIS_TOKEN_PARAM);
        if (!token) {
            console.error("[HisEmbed] no token in URL");
            setStatus("failed");
            return;
        }

        const runExchange = async () => {
            try {
                const result: any = await ExchangeHisToken({ randomToken: decodeURIComponent(token) });
                const tokenData = result?.data?.data;

                if (!tokenData?.accessToken) {
                    console.error("[HisEmbed] exchange response missing accessToken", result);
                    setStatus("failed");
                    return;
                }

                handleAuthSuccess({ data: tokenData, setIsLoggedIn });
                setStatus("ready");
            } catch (error) {
                console.error("[HisEmbed] exchange failed", error);
                setStatus("failed");
            }
        };

        runExchange();
    }, [searchParams, setIsLoggedIn]);

    useEffect(() => {
        if (status !== "ready" || !nationalId) return;
        setCustomSearchData((prev: any) => ({ ...prev, keyword: nationalId }));
    }, [status]);

    if (status === "pending") return null;

    if (status === "failed") {
        return (
            <div className="his-embed-error">
                <div className="his-embed-error-card">
                    <Icon icon="ic:outline-error-outline" width={48} className="his-embed-error-icon" />
                    <p className="his-embed-error-message">{t("hisAuthFailed")}</p>
                    {/* <button className="login-content-login-btn his-embed-error-btn" onClick={() => navigate("/login")}>
                        {t("login")}
                    </button> */}
                </div>
            </div>
        );
    }

    return <AddMedicine />;
};

export default HisEmbed;
